module.exports = __webpack_public_path__ + "img/Group 512.c7dc6a24.png";